import {
  BookOpenIcon,
  FileTextIcon,
  ListChecksIcon,
  ClipboardCheckIcon,
  PaletteIcon,
  GraduationCapIcon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export const kitContents: { icon: LucideIcon; title: string; description: string }[] = [
  {
    icon: BookOpenIcon,
    title: '8 Volumi Completi',
    description:
      'Un volume per ogni anno scolastico, dalla 1ª Primaria alla 3ª Media: un percorso continuo dai 6 ai 14 anni.',
  },
  {
    icon: FileTextIcon,
    title: '480+ Pagine di Contenuti',
    description: 'Unità pronte, schede operative, glossari e verifiche.',
  },
  {
    icon: ListChecksIcon,
    title: 'Attività Passo-Passo',
    description: 'Ogni tecnica spiegata e messa in pratica subito, senza improvvisare.',
  },
  {
    icon: ClipboardCheckIcon,
    title: 'Verifiche e Griglie di Valutazione',
    description: 'Autovalutazione per gli studenti, soluzioni pronte per il docente.',
  },
  {
    icon: PaletteIcon,
    title: 'Tecnica e Storia dell’Arte',
    description:
      'Disegno, pittura, colore, composizione e i grandi movimenti artistici, dalla Preistoria al Contemporaneo.',
  },
  {
    icon: GraduationCapIcon,
    title: 'Preparazione all’Esame di Stato',
    description: 'Portfolio artistico e ripasso guidato per la Terza Media (Volume 8).',
  },
]
